import { render, staticRenderFns } from "./TemplateUploadPdf.vue?vue&type=template&id=775a9048"
import script from "./TemplateUploadPdf.vue?vue&type=script&lang=js"
export * from "./TemplateUploadPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports